import { inputInitState } from "./init_state";
import * as ActionTypes from "../actions/action_type";

const initialStete = {
  stores: {
    data: inputInitState,
  },
};
export const unpay_view_info = (state = initialStete, action) => {
  switch (action.type) {
    case ActionTypes.getViewSuccessAction: {
      return { ...state, stores: action.payload };
    }
    case ActionTypes.getUnPayViewFailAction:
    case ActionTypes.getUnPayViewResetAction:
      return { ...state, stores: initialStete.stores };
    default:
      return state;
  }
};
